module.exports = __webpack_public_path__ + "img/vip_level_2.e277b3ad.png";